import { Component, OnInit, Input } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import Swal from "sweetalert2";
import { ConstantHelper } from "../_helpers/constant.helper";
import { AppConfig } from "../app.config";

@Component({
  selector: "app-screen-capture",
  templateUrl: "./screen-capture.component.html",
  styleUrls: ["./screen-capture.component.css"],
})
export class ScreenCaptureComponent implements OnInit {
  @Input() patientName: string = "";
  @Input() physicianName: string = "";

  constructor(private http: HttpClient, private appConfig: AppConfig) {}

  ngOnInit(): void {}

  startExtension() {
    var loggedInUserId = localStorage.getItem("loggedInUserId");
    var physicianId = localStorage.getItem("loggedInUserId");
    var patientId = sessionStorage.getItem("patientId");
    var demographicId = sessionStorage.getItem("formId");
    var company_slug = ConstantHelper.COMPANY_SLUG;
    var companyId = 4;
    var docType1 = 17;
    var uploadApiUrl =
      this.appConfig.getPhpUrl() + "uploadDocumentToPatient.php";

    const patientNameFormatted = this.patientName
      .replace(/,\s/g, "-")
      .replace(/\s+/g, " ")
      .replace(/\s/g, "-")
      .trim();
    const physicianNameFormatted = this.physicianName
      .replace(/\s+/g, " ")
      .replace(/\s/g, "-")
      .trim();


    const akshay = `loggedInUserId:${+loggedInUserId},physicianId:${+physicianId},patientId:${+patientId}, demographicId:${+demographicId},company_slug:${company_slug},companyId:${+companyId},docType1:${docType1},uploadApiUrl:${uploadApiUrl},patientName:${patientNameFormatted},physicianName:${physicianNameFormatted},supporter`;

    var encodedPayload = encodeURIComponent(akshay);

    const appUrl = `AHSScreenCaptureAppv2://payload=${encodedPayload}`;
    console.log("appurl", appUrl);

    let isAppOpened = false;
    let maxWaitTime = 6000; // Maximum wait time to detect app opening (6 seconds)
    let checkInterval = 500; // Check every 500ms
    let elapsedTime = 0;

    function handleBlur() {
      isAppOpened = true;
    }

    function handleFocus() {
      if (isAppOpened) {
        window.location.reload(); // Reload when the user quits the app
      }
    }

    // **Remove existing event listeners and reattach fresh ones**
    window.removeEventListener("blur", handleBlur);
    window.addEventListener("blur", handleBlur);

    Swal.fire({
      title: "Opening AHS Screen Capture...",
      text: "Please wait while we try to launch the application.",
      icon: "info",
      timer: 2000, // Auto close in 2 seconds
      showConfirmButton: false,
    });

    // **Create and launch the iframe to open the external app**
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appUrl;
    document.body.appendChild(iframe);

    // **Reset `isAppOpened` for each attempt to avoid leftovers**
    isAppOpened = false;

    // **Start the check after 1-second initial delay**
    setTimeout(() => {
      const checkAppOpened = setInterval(async () => {
        elapsedTime += checkInterval;

        if (isAppOpened || elapsedTime >= maxWaitTime) {
          clearInterval(checkAppOpened);
          document.body.removeChild(iframe);
          window.removeEventListener("blur", handleBlur);

          // **Ensure alert shows if app never opened**
          if (!isAppOpened) {
            const alertStatus = await Swal.fire({
              title: "AHS Screen Capture Application Not Installed",
              text: "Please select your operating system to download and install the application.",
              icon: "info",
              showCancelButton: false,
              confirmButtonText: "Download for Windows",
              confirmButtonColor: "#3085d6",
              showDenyButton: true,
              denyButtonText: "Download for macOS",
              denyButtonColor: "#4CAF50",
            });

            if (alertStatus.isConfirmed) {
              window.open(
                "https://elemrexproductionstorage.blob.core.windows.net/application/AHS-Screen-Capture-App-Version-2.exe",
                "_blank"
              );
            } else if (alertStatus.isDenied) {
              window.open(
                "https://elemrexproductionstorage.blob.core.windows.net/application/AHS_Screen_Capture_App2 0.0.4.dmg",
                "_blank"
              );
            }
          }
        }
      }, checkInterval);
    }, 1000);
  }
}
